module.exports = __webpack_public_path__ + "static/media/arrow-black.9e87b131.svg";